<pr-page-splash>
  <pt-sign-in
    logoSrc="/assets/icons/principle-row-dark.png"
    [workspaceSelectors]="workspaceSelectors"
    (afterSuccess)="afterSuccess()"
  />
</pr-page-splash>
